import type { JSX } from 'react';
import { FormSection } from '@ksyos/design-system';
import type { BariPreNurseSpecialistMedScreeningReportData } from '@common/validation/customControls/bariPre/bariPreNurseSpecialistMedScreeningReport/types';
import { TextAreaFormGroup } from '@frontend/components/pages/episodeCategory/customControls/processActivityFormGroupFields';
import { YesNoWithConditionalTextAreaFormGroup } from '@frontend/components/pages/episodeCategory/customControls/YesNoWithConditionalTextAreaFormGroup';
import { useProcessActivityEditContext } from '@frontend/utils';

export function BariPreNurseSpecialistMedScreeningReportMedicatie(): JSX.Element {
    const { data } = useProcessActivityEditContext<BariPreNurseSpecialistMedScreeningReportData>();

    return (
        <FormSection title="Medicatie">
            <YesNoWithConditionalTextAreaFormGroup
                fieldKey="medicatie"
                fieldValue={data.medicatie}
                isRequired={true}
                label="Medicatie"
                textAreaFieldKey="medicatie_toelichting"
                textAreaLabel="Toelichting actuele medicatie"
            />
            <TextAreaFormGroup
                fieldKey="allergieen"
                isRequired={true}
                label="Allergieën"
            />
        </FormSection>
    );
}
